import '../styles/global.scss';
import { ReactElement, useEffect } from 'react';
import type { AppProps } from 'next/app';

import { initErrorHandler } from '../services/error-handler';
import { useLDProvider } from '../services/feature-flag';
import { isLaunchDarklyEnabled } from '../services/utils';
import { setMixpanelDeviceId } from '../utils/cookies';

initErrorHandler();

type AppPropsType = AppProps & { err: Error; pageProps: any };

function App({ Component, pageProps, router, err }: AppPropsType): ReactElement {
  const shouldUseLd = isLaunchDarklyEnabled(router.route);
  useEffect(() => {
    let attempts = 0;
    let interval: any = null;
    interval = setInterval(() => {
      const isSet = setMixpanelDeviceId((window as any)?.mixpanel?.get_distinct_id?.());
      if (isSet || attempts > 10) {
        clearInterval(interval);
      }
      attempts += 1;
    }, 1000);
  }, []);
  if (shouldUseLd) {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    const LDProvider = useLDProvider(pageProps.user);
    return (
      <LDProvider>
        {/* eslint-disable-next-line react/jsx-props-no-spreading -- Framework code */}
        <Component {...pageProps} err={err} />
      </LDProvider>
    );
  }
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading -- Framework code */
    <Component {...pageProps} err={err} />
  );
}

export default App;
